import apiFetch from '../../apiFetch'

export default function (idBioseguridad, tipoAccion, token) {
  return apiFetch({endPoint: 'Bioseguridad/getBioseguridad?idBioSeguridad=' + idBioseguridad + '&tipoAccion=' + tipoAccion, method: 'GET', body: null, token: token})
}
